import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';

export const scenariosBrowseRoutes: Routes = [
  {
    path: 'browse',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@features/scenarios-browse/scenarios-browse.component').then((c) => c.ScenariosBrowseComponent),
    data: {
      showHomePage: true,
    },
  },
];
